import { render, staticRenderFns } from "./National-cultural.vue?vue&type=template&id=f7859402&scoped=true"
import script from "./National-cultural.vue?vue&type=script&lang=js"
export * from "./National-cultural.vue?vue&type=script&lang=js"
import style0 from "./National-cultural.vue?vue&type=style&index=0&id=f7859402&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7859402",
  null
  
)

export default component.exports